// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PorticoDataGroupModel {
    static getAttributeTypeMap() {
        return PorticoDataGroupModel.attributeTypeMap;
    }
}
PorticoDataGroupModel.discriminator = undefined;
PorticoDataGroupModel.additionalProperties = false;
PorticoDataGroupModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    },
    {
        "name": "dataGroupTypeId",
        "baseName": "dataGroupTypeId",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "isPrivate",
        "baseName": "isPrivate",
        "type": "boolean"
    },
    {
        "name": "createdBy",
        "baseName": "createdBy",
        "type": "number"
    },
    {
        "name": "createdOn",
        "baseName": "createdOn",
        "type": "Date"
    },
    {
        "name": "dataRows",
        "baseName": "dataRows",
        "type": ""
    },
];
//# sourceMappingURL=porticoDataGroupModel.js.map